import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { translations } from './translations';

const STORAGE_KEY = 'havelbr-lang';
const SUPPORTED = ['pt', 'en'];

const detectInitialLang = () => {
  if (typeof window === 'undefined') return 'pt';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED.includes(stored)) return stored;
  const nav = (window.navigator.language || 'pt').toLowerCase();
  return nav.startsWith('en') ? 'en' : 'pt';
};

const LanguageContext = createContext({ lang: 'pt', setLang: () => {}, t: translations.pt });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectInitialLang);
  const [searchParams] = useSearchParams();

  // Deep-link: ?lang=en / ?lang=pt sobrepõe e persiste o idioma.
  useEffect(() => {
    const requested = (searchParams.get('lang') || '').toLowerCase();
    if (SUPPORTED.includes(requested)) {
      setLang(requested);
    }
  }, [searchParams]);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang === 'en' ? 'en' : 'pt-BR';
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
